import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './super-admin.css';
import Charts from '../../components/charts/charts';
import ChartsPie from '../../components/charts/chartsPie';

class SuperAdminDashboard extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (
        <div className="m-grid m-grid--hor m-grid--root m-page" style={{ minHeight: '100vh'}}>
        <body className="m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--fixed m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default">
		<div className="m-grid m-grid--hor m-grid--root m-page">
			<header id="m_header" className="m-grid__item    m-header " m-minimize-offset="200" m-minimize-mobile-offset="200">
				<div className="m-container m-container--fluid m-container--full-height">
					<div className="m-stack m-stack--ver m-stack--desktop">
						<div className="m-stack__item m-brand  m-brand--skin-dark ">
							<div className="m-stack m-stack--ver m-stack--general">
								<div className="m-stack__item m-stack__item--middle m-brand__logo">
									<a href="index.html" className="m-brand__logo-wrapper">
										<img alt="" src="../../../assets/app/media/img/petpos-white.png" style={{width:'80px'}}/>
									</a>
								</div>
								<div className="m-stack__item m-stack__item--middle m-brand__tools">
									<a href="" id="m_aside_left_minimize_toggle" className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block">
										<span></span>
									</a>
									<a href="" id="m_aside_left_offcanvas_toggle" className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
										<span></span>
									</a>
									<a id="m_aside_header_menu_mobile_toggle" href="" className="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
										<span></span>
									</a>
									<a id="m_aside_header_topbar_mobile_toggle" href="" className="m-brand__icon m--visible-tablet-and-mobile-inline-block">
										<i className="flaticon-more"></i>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
			<div className="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
				<button className="m-aside-left-close  m-aside-left-close--skin-dark " id="m_aside_left_close_btn">
					<i className="la la-close"></i>
				</button>
				<div id="m_aside_left" className="m-grid__item	m-aside-left  m-aside-left--skin-dark ">
					<div id="m_ver_menu" className="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark " m-menu-vertical="1" m-menu-scrollable="1" m-menu-dropdown-timeout="500" style={{position: 'relative'}}>
						<ul className="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
							<li className="m-menu__item  m-menu__item--active" aria-haspopup="true">
								<a href="index.html" className="m-menu__link ">
									<i className="m-menu__link-icon flaticon-line-graph"></i>
									<span className="m-menu__link-title">
										<span className="m-menu__link-wrap">
											<span className="m-menu__link-text">Dashboard</span>
											<span className="m-menu__link-badge">
												<span className="m-badge m-badge--danger">2</span>
											</span>
										</span>
									</span>
								</a>
							</li>
							<li className="m-menu__section ">
								<h4 className="m-menu__section-text">Components</h4>
								<i className="m-menu__section-icon flaticon-more-v3"></i>
							</li>
							<li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
								<a href="" className="m-menu__link m-menu__toggle">
									<i className="m-menu__link-icon flaticon-paper-plane"></i>
									<span className="m-menu__link-text">Subscriptions</span>
									<i className="m-menu__ver-arrow la la-angle-right"></i>
								</a>
							</li>
							<li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
								<a href="" className="m-menu__link m-menu__toggle">
									<i className="m-menu__link-icon flaticon-users"></i>
									<span className="m-menu__link-text">Users</span>
									<i className="m-menu__ver-arrow la la-angle-right"></i>
								</a>
							</li>
							<li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
								<a href="" className="m-menu__link m-menu__toggle">
									<i className="m-menu__link-icon flaticon-graph"></i>
									<span className="m-menu__link-text">Sales</span>
									<i className="m-menu__ver-arrow la la-angle-right"></i>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div className="m-grid__item m-grid__item--fluid m-wrapper">
					<div className="m-subheader ">
						<div className="d-flex align-items-center">
							<div className="mr-auto">
								<h3 className="m-subheader__title ">Dashboard</h3>
							</div>
						</div>
					</div>
                    <div className="m-content">
                        <div className="row">
							<div className="col-xl-3">
								<div className="m-portlet m-portlet--bordered-semi m-portlet--full-height" style={{backgroundColor:'#626be3'}}>
									<div className="card-body">
										<div className="media d-flex align-items-center ">
											<div className="mr-4 rounded-circle bg-white sr-icon-box text-purple">
												<i className="flaticon-paper-plane m--font-brand"></i>
											</div>
											<div className="media-body text-light">
												<h4 className="mb-0">No of Subscriptions</h4>
												<span>10,523</span>
											</div>
										</div>
									</div>
                                </div>
                            </div>
                            <div className="col-xl-3">
								<div className="m-portlet m-portlet--bordered-semi m-portlet--full-height" style={{backgroundColor:'#3da5f4'}}>
									<div className="card-body">
										<div className="media d-flex align-items-center ">
											<div className="mr-4 rounded-circle bg-white sr-icon-box text-purple">
												<i className="flaticon-users m--font-info"></i>
											</div>
											<div className="media-body text-light">
												<h4 className="mb-0">No of Registered Users</h4>
												<span>10,523</span>
											</div>
										</div>
									</div>
                                </div>
                            </div>
                            <div className="col-xl-3">
								<div className="m-portlet m-portlet--bordered-semi m-portlet--full-height" style={{backgroundColor:'#f1536e'}}>
									<div className="card-body">
										<div className="media d-flex align-items-center ">
											<div className="mr-4 rounded-circle bg-white sr-icon-box text-purple">
												<i className="flaticon-graph m--font-danger"></i>
											</div>
											<div className="media-body text-light">
												<h4 className="mb-0">No of Sales</h4>
												<span>99,858</span>
											</div>
										</div>
									</div>
                                </div>
                            </div>
                            <div className="col-xl-3">
								<div className="m-portlet m-portlet--bordered-semi m-portlet--full-height" style={{backgroundColor:'#22ae7a'}}>
								<div className="card-body">
										<div className="media d-flex align-items-center ">
											<div className="mr-4 rounded-circle bg-white sr-icon-box text-purple">
												<i className="flaticon-coins m--font-success"></i>
											</div>
											<div className="media-body text-light">
												<h4 className="mb-0">Income</h4>
												<span>99,858</span>
											</div>
										</div>
									</div>
                                </div>
                            </div>
                        </div>
						<div className="row">
							<div className="col-xl-6 col-md-6">
								<div className="card card-shadow mb-4">
									<div className="card-header border-0">
										<div className="custom-title-wrap bar-success">
											<div className="custom-title">Progress of Subscriptions</div>
											<div className="custom-post-title">Outstanding area chart example is given bellow</div>
										</div>
									</div>
								
									<div className="chart" style={{padding:'20px'}}><Charts/></div>
								</div>
							</div>
							<div className="col-xl-3 col-md-3">
								<div className="card card-shadow mb-4">
									<div className="card-header border-0">
										<div className="custom-title-wrap bar-success">
											<div className="custom-title">Progress of Users</div>
											<div className="custom-post-title">Outstanding area chart example is given bellow</div>
										</div>
									</div>
								
									<div className="chart" style={{padding:'20px'}}><ChartsPie/></div>
								</div>
							</div>
							<div className="col-xl-3 col-md-3">
								<div className="card card-shadow mb-4">
									<div className="card-header border-0">
										<div className="custom-title-wrap bar-primary">
											<div className="custom-title">Today's Activity</div>
											<div className="custom-post-title">User's Activites</div>
										</div>
									</div>
									<div className="card-body">
										<ul className="list-unstyled base-timeline">
											<li className="time-dot-primary">
												<div className="base-timeline-info">
													<a href="#">John123</a> Successfully purchased item#26
												</div>
												<small className="text-muted">
													28 mins ago
												</small>
											</li>
											<li className="time-dot-danger">
												<div className="base-timeline-info">
													<a href="#" className="text-danger">Farnandez</a> placed the order for accessories
												</div>
												<small className="text-muted">
													2 days ago
												</small>
											</li>
											<li className="time-dot-purple">
												<div className="base-timeline-info">
													User <a href="#" className="text-purple">Lisa Maria</a> checked out from the market
												</div>
												<small className="text-muted">
													12 mins ago
												</small>
											</li>
											<li className="time-dot-turquoise">
												<div className="base-timeline-info">
													<a href="#" className="text-info">Charlie Johnson  </a> joined DashLab last week. Congrats to him
												</div>
												<small className="text-muted">
													3 days ago
												</small>
											</li>
										</ul>
									</div>
								</div>
               				 </div>
						</div>
                	 </div>
		   		 </div>
             </div>
		</div>
    </body>
    </div>


    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(SuperAdminDashboard));
